import React from 'react';
import './UpgradeModal.css';

const UpgradeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <div className="modal-overlay">
      <div className="upgrade-modal">
        <div className="modal-header">
          <h2>Upgrade Your Account</h2>
          <button style={{color: 'black'}} className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="subscription-plans">
          <div className="plan">
            <h3>Monthly</h3>
            <div className="price">$7<span>/month</span></div>
            <ul className="features">
              <li>Unlimited novels, chapters & scenes</li>
              <li>Unlimited characters, locations & lore items</li>
              <li>Advanced AI assistance</li>
              <li>AI Chat</li>
              <li>Export to DOCX/PDF/MD</li>
            </ul>

            <a style={{color: 'white', textDecoration: 'none'}} href={`https://buy.stripe.com/eVadS82vp17eeWsfZ0?prefilled_email=${user.email}`}><button style={{marginTop: "35px"}}>Subscribe Now</button></a>

          </div>
          
          <div className="plan featured">
            <div className="best-value">Best Value</div>
            <h3>Annual</h3>
            <div className="price">$70<span>/year</span></div>
            <div className="savings">Save $14</div>
            <ul className="features">
              <li>All monthly features</li>
              <li>2 months free!</li>
            </ul>
                <a style={{position: 'absolute', bottom: '23px', width: '88%', left: '6%', color: 'white', textDecoration: 'none'}} href={`https://buy.stripe.com/cN2bK04Dx9DKcOk144?prefilled_email=${user.email}`}><button>Subscribe Now</button></a>
          </div>
        </div>
        
        <div className="guarantee">
          <p>Cancel anytime.</p>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
